import {
  addDoc,
  collection,
  doc,
  getDoc,
  getDocs,
  limit,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  setDoc,
  updateDoc,
  where,
  writeBatch,
} from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';
import { FIREBASE_CONFIG } from '../config/Config';

const appId = FIREBASE_CONFIG.projectId;
export const MASTER_PATH = ['artifacts', appId, 'public', 'data', 'contract_templates', 'master_v8'];
const AUTOSAVE_PATH = ['artifacts', appId, 'public', 'data', 'contract_templates', 'cloud_autosave_v1'];
const CLIENTS_PATH = ['artifacts', appId, 'public', 'data', 'clients'];
const DOCUMENTS_PATH = ['artifacts', appId, 'public', 'data', 'documents'];
const LEDGER_PATH = ['artifacts', appId, 'public', 'data', 'financial_ledger'];

export async function fetchContractMasterV8() {
  const ref = doc(db, ...MASTER_PATH);
  const snap = await getDoc(ref);
  return snap.exists() ? snap.data() : null;
}

export async function saveContractMasterV8(payload) {
  const ref = doc(db, ...MASTER_PATH);
  await setDoc(ref, payload);
}

export async function fetchContractAutosave() {
  const ref = doc(db, ...AUTOSAVE_PATH);
  const snap = await getDoc(ref);
  return snap.exists() ? snap.data() : null;
}

export function subscribeContractMasterV8(callback) {
  const ref = doc(db, ...MASTER_PATH);
  return onSnapshot(ref, (snap) => {
    callback(snap.exists() ? snap.data() : null);
  });
}

export async function saveContractAutosave(payload) {
  const ref = doc(db, ...AUTOSAVE_PATH);
  await setDoc(ref, { ...payload, source: 'cloud_autosave', updatedAt: serverTimestamp() });
}

export function subscribeClientData(clientId, callback) {
  const ref = doc(db, ...CLIENTS_PATH, clientId);
  return onSnapshot(ref, (snap) => {
    if (!snap.exists()) return;
    callback({ id: snap.id, ...snap.data() });
  });
}

export async function fetchClientData(clientId) {
  const ref = doc(db, ...CLIENTS_PATH, clientId);
  const snap = await getDoc(ref);
  return snap.exists() ? { id: snap.id, ...snap.data() } : null;
}

export async function addFinancialLedgerEntries(entries) {
  const batch = writeBatch(db);
  const col = collection(db, ...LEDGER_PATH);
  entries.forEach((entry) => {
    const ref = doc(col);
    batch.set(ref, { ...entry, createdAt: serverTimestamp() });
  });
  await batch.commit();
}

export async function publishContractDocument(docRef, payload) {
  await setDoc(docRef, payload, { merge: true });
}

export async function addContractProntuarioNote(clientId, note) {
  const notesRef = collection(db, ...CLIENTS_PATH, clientId, 'notes');
  await addDoc(notesRef, { ...note, createdAt: serverTimestamp() });
}

export async function getNextContractDocumentRef() {
  const col = collection(db, ...DOCUMENTS_PATH);
  return doc(col);
}

export async function getFreshContractMasterV8() {
  return fetchContractMasterV8();
}
